import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import { useEffect, useState } from 'react'
import { UAParser } from 'ua-parser-js'
import Modal from '../Modal'
dayjs.extend(isToday)

export default () => {
  const [status, setStatus] = useState(0) // 0符合 1不是chrome 2chrome版本太低

  useEffect(() => {
    if (!localStorage.BROWSER_TIPS_TIME || isNaN(Number(localStorage.BROWSER_TIPS_TIME)) || (localStorage.BROWSER_TIPS_TIM && !dayjs(localStorage.BROWSER_TIPS_TIME).isToday())) {
      const parser = new UAParser(window.navigator.userAgent)
      const res = parser.getBrowser()
      console.log(res)
      const v = (v: string) => {
        const major = Number(v.split('.')[0])
        if (major < 100) {
          return false
        }
        return true
      }
      if (res.name !== 'Chrome') {
        setStatus(1)
        return
      }
      if (!v(res.version || '')) {
        setStatus(2)
        return
      }
    }
  }, [])

  return (
    <Modal
      show={status !== 0}
      cancel={() => {
        localStorage.BROWSER_TIPS_TIME = dayjs().valueOf()
        setStatus(0)
      }}
      title="提示"
      cancelText="明天提醒我"
    >
      {}
      <div className="mx-auto my-[20px] w-full text-center">
        {status === 2 ? '你的谷歌浏览器太旧了请升级或重新下载' : '请使用谷歌浏览器访问本网站'}&ensp;
        <a className="text-blue-600" href="https://www.google.cn/chrome/" target="_blank">
          马上下载
        </a>
      </div>
    </Modal>
  )
}
